'use client';
import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React from 'react';
import { IPropsComment } from './_types';
import CommentDesktop from './comment.desktop';
import CommentMobile from './comment.mobile';

const AddComment = ({
  onOpenChange,
  handleSaveComment,
  setComment,
  comment,
}: IPropsComment) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      {isDesktop ? (
        <CommentDesktop
          comment={comment}
          setComment={setComment}
          onOpenChange={onOpenChange}
          handleSaveComment={handleSaveComment}
        />
      ) : (
        <CommentMobile
          comment={comment}
          setComment={setComment}
          onOpenChange={onOpenChange}
          handleSaveComment={handleSaveComment}
        />
      )}
    </>
  );
};

export default AddComment;
